import React from 'react';
import styles from './Button.module.scss';

const Button = props => {
  const buttonContent = {
    left: '&larr;',
    right: '&rarr;'
  };

  return (
    <button
      className={styles.button}
      dangerouslySetInnerHTML={{__html: buttonContent[props.type]}}
      style={{
        [props.type]: '20px'
      }}
      onClick={() => props.handleClick(props.type)}
    >
    </button>
  );
}

export default Button;